import { connectMenu } from 'instantsearch.js/es/connectors';
import menuTemplate from '../templates/menuRadio';

const transformItems = (items) => {
  const defaultItem = {
    label: 'All',
    value: '',
    isRefined: true,
  };

  const updatedItems = items
    .filter((item) => item.value !== 'Indeterminate')
    .map((item) => {
      if (item.isRefined) {
        defaultItem.isRefined = false;
      }

      return item;
    });

  return [...updatedItems, defaultItem];
};

const renderMenu = (renderOptions) => {
  const { widgetParams, refine } = renderOptions;
  const $container = widgetParams.container;

  $container.innerHTML = menuTemplate('In-Person or Remote:', renderOptions);

  [...$container.querySelectorAll('a')].forEach((element) => {
    element.addEventListener('click', (event) => {
      event.preventDefault();

      if (event.currentTarget.dataset.checked === 'true') {
        return;
      }

      refine(event.currentTarget.dataset.value);
    });
  });
};

const connectedMenu = connectMenu(renderMenu);

export const presenceMenu = ({ container }) =>
  connectedMenu({
    container,
    attribute: 'presence',
    sortBy: ['name:desc'],
    transformItems,
  });
